import { isEmpty, some } from 'lodash'

const DISH_FIELDS_CONFIG = {
  NAME: {
    value: 'name',
    label: 'Name',
    isTableField: true,
    columnWidth: '230px',
    isFixed: true,
    isHideable: false,
    isEditable: true,
    columnFixedPosition: 'left',
  },
  CERTAINTY: {
    value: 'certainty',
    label: 'Certainty',
    isTableField: true,
    columnWidth: '100px',
    isHideable: false,
  },
  TIER: {
    value: 'tier',
    label: 'Tier',
    isTableField: true,
    columnWidth: '100px',
    isHideable: false,
  },
  PRICE: {
    value: 'price',
    label: 'Price',
    isTableField: true,
    columnWidth: '160px',
    isEditable: true,
    isHideable: false,
  },
  MENU_TITLE: {
    value: 'menuTitle',
    label: 'Menu title',
    isTableField: true,
    columnWidth: '300px',
    isHideable: false,
  },
  DISH_TYPE: {
    value: 'dishType',
    label: 'Dish type',
    isTableField: true,
    columnWidth: '120px',
    isHideable: false,
    isEditable: true,
  },
  DIET_DESCRIPTORS: {
    value: 'dietDescriptors',
    label: 'Diet descriptors',
    isTableField: true,
    columnWidth: '260px',
    isHideable: true,
  },
  DIETS: {
    value: 'diets',
    label: 'Diets',
    isTableField: true,
    columnWidth: '120px',
    isHideable: false,
    isEditable: true,
  },
  COURSE_TYPE: {
    value: 'courseType',
    label: 'Course type',
    isTableField: true,
    columnWidth: '120px',
    isHideable: false,
    isEditable: true,
  },
  DESCRIPTION: {
    value: 'description',
    label: 'Description',
    isTableField: true,
    columnWidth: '400px',
    isHideable: false,
    isEditable: true,
  },
  INGREDIENTS: {
    value: 'ingredients',
    label: 'Ingredients text',
    isTableField: true,
    columnWidth: '400px',
    isHideable: true,
    isEditable: true,
  },
  MAIN_INGREDIENTS: {
    value: 'mainIngredients',
    label: 'Main ingredients',
    isTableField: true,
    columnWidth: '300px',
    isHideable: false,
    isEditable: true,
  },
  CHOICE_INGREDIENTS: {
    value: 'choiceIngredients',
    label: 'Choice ingredients',
    isTableField: true,
    isEditable: true,
    columnWidth: '300px',
  },
  ALLERGENS: {
    value: 'allergens',
    label: 'Allergens',
    isTableField: true,
    columnWidth: '200px',
    isHideable: false,
    isEditable: true,
  },
  ALLERGEN_DESCRIPTORS: {
    value: 'allergenDescriptors',
    label: 'Allergen descriptors',
    isTableField: true,
    columnWidth: '260px',
    isHideable: true,
  },
  ADDON_DESCRIPTORS: {
    value: 'addonDescriptors',
    label: 'Addon descriptors',
    isTableField: true,
    columnWidth: '300px',
    isHideable: true,
  },
  MENU_TITLE_DIET_DESCRIPTORS: {
    value: 'menuTitleDietDescriptors',
    shouldDisplay: ({ menuTitleParents }) =>
      some(
        menuTitleParents,
        ({ dietDescriptors }) => !isEmpty(dietDescriptors),
      ),
    label: 'Menu title diet descriptors',
    isTableField: true,
    columnWidth: '200px',
    isHideable: true,
  },
  MENU_TITLE_ALLERGEN_DESCRIPTORS: {
    value: 'menuTitleAllergenDescriptors',
    shouldDisplay: ({ menuTitleParents }) =>
      some(
        menuTitleParents,
        ({ allergenDescriptors }) => !isEmpty(allergenDescriptors),
      ),
    label: 'Menu title allergen descriptors',
    isTableField: true,
    columnWidth: '200px',
    isHideable: true,
  },
  MENU_TITLE_ADDON_DESCRIPTORS: {
    value: 'menuTitleAddonDescriptors',
    shouldDisplay: ({ menuTitleParents }) =>
      some(
        menuTitleParents,
        ({ addonDescriptors }) => !isEmpty(addonDescriptors),
      ),
    label: 'Menu title addon descriptors',
    isTableField: true,
    columnWidth: '200px',
    isHideable: true,
  },
  DISH_ACTIONS: {
    value: 'actions',
    label: 'Actions',
    isTableField: true,
    columnWidth: '120px',
    isHideable: false,
  },
  LOW_PRICE: {
    value: 'lowPrice',
    label: 'Low price',
    isTableField: false,
  },
  HIGH_PRICE: {
    value: 'highPrice',
    label: 'Low price',
    isTableField: false,
  },
  BLACKLISTED_INGREDIENTS: {
    value: 'blacklistedIngredients',
    label: 'Blacklisted ingredients',
    isTableField: false,
  },
  ADDITIONAL_INGREDIENTS: {
    value: 'additionalIngredients',
    label: 'Additional ingredients',
    isTableField: false,
  },
  CUISINE_TYPE: {
    value: 'cuisineType',
    label: 'Cuisine type',
    isTableField: true,
    columnWidth: '120px',
    isHideable: false,
    isEditable: false,
  },
  ID: {
    value: 'id',
    label: 'Id',
    isTableField: true,
    columnWidth: '100px',
    isHideable: false,
  },
  IS_PUBLISHED: {
    value: 'isPublished',
    label: 'Published',
    columnWidth: '100px',
    isHideable: false,
    isTableField: true,
  },
  AUTOEAT_ID: {
    value: 'autoeatId',
    label: 'Autoeat Id',
    isTableField: true,
    columnWidth: '100px',
    isHideable: false,
  },
}

export default DISH_FIELDS_CONFIG
